import type {} from '@mui/material/themeCssVarsAugmentation';
import { Paper as MuiPaper } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ResultsPageContent = styled(MuiPaper)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    marginTop: theme.spacing(2),
    backgroundColor: 'transparent',
}));
